import axiosInstance from '@/utils/http/AxiosInstance';

// 通用的响应处理函数（抽离逻辑，避免重复）
const handleResponse = (response, url) => {
    // 空值兜底：如果 response 不存在，直接返回空
    if (!response) return null;

    // 安全获取 headers，避免 undefined 报错
    const headers = response.headers || {};
    const contentType = headers['content-type'] || '';

    // 处理下载接口的 JSON 响应（ArrayBuffer 转字符串）
    if (url.includes("download") && contentType.includes('application/json')) {
        try {
            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(response.data);
            return JSON.parse(text);
        } catch (e) {
            console.error('下载接口 JSON 解析失败:', e);
            return response.data;
        }
    }

    // 处理二进制文件响应
    if (contentType.includes('application/octet-stream')) {
        const blob = new Blob([response.data], { type: contentType });
        return {
            data: blob,
            fileName: headers['content-disposition'] || '未命名文件'
        };
    }

    // 普通响应返回 data
    return response.data || response;
};

export async function get(url, params) {
    try {
        const response = await axiosInstance.get(url, { params });
        return handleResponse(response, url);
    } catch (error) {
        console.error('GET 请求失败:', url, error);
        // 抛出异常，让业务层可以捕获处理
        throw error;
    }
}

export async function post(url, data) {
    try {
        let response;
        // 下载接口特殊配置
        if (url.includes("download")) {
            response = await axiosInstance.post(url, data, { responseType: 'arraybuffer' });
        } else {
            response = await axiosInstance.post(url, data);
        }
        // 统一处理响应，避免访问 undefined 的 headers
        return handleResponse(response, url);
    } catch (error) {
        console.error('POST 请求失败:', url, error);
        // 抛出异常，让登录页面等业务层可以捕获
        throw error;
    }
}

export async function fileShowPost(url, data) {
    try {
        const response = await axiosInstance.request({
            method: 'post',
            url: url,
            data: data,
            responseType: 'arraybuffer'
        });
        return handleResponse(response, url);
    } catch (error) {
        console.error('fileShowPost 请求失败:', url, error);
        throw error;
    }
}

/** 上传文件 */
export async function uploadFilePost(url, formData) {
    try {
        const response = await axiosInstance.request({
            method: 'post',
            url: url,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return handleResponse(response, url);
    } catch (error) {
        console.error('文件上传失败:', url, error);
        throw error;
    }
}

/** 
 * @deprecated 直接使用post
 */
export async function fileDownloadPost(url, data) {
    try {
        const response = await axiosInstance.request({
            method: 'post',
            url: url,
            data: data,
            responseType: 'blob'
        });
        return handleResponse(response, url);
    } catch (error) {
        console.error('文件下载失败:', url, error);
        throw error;
    }
}

export async function put(url, data) {
    try {
        const response = await axiosInstance.put(url, data);
        return handleResponse(response, url);
    } catch (error) {
        console.error('PUT 请求失败:', url, error);
        throw error;
    }
}

export async function del(url, params) {
    try {
        const response = await axiosInstance.delete(url, { params });
        return response.data;
    } catch (error) {
        console.error('DELETE 请求失败:', url, error);
        throw error;
    }
}